<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="10" :sm="8">
            <a-form-item :label="language['upload.date']">
              <j-date :placeholder="language['common.chooseStartDate']" :showTime="false" dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.startDate"></j-date>
              <span class="query-group-split-cust"></span>
              <j-date :placeholder="language['common.chooseEndDate']" :showTime="false"  dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.endDate"></j-date>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item :label="language['system.certificate.system']">
              <a-select v-model="queryParam.systemCode"  allowClear @change="systemCodeChange">
                <a-select-option v-for="(item,index) in systemlist" :key="index" :value="item.systemCode">{{item.systemName}}</a-select-option>
<!--                <a-select-option value="nonemployee">{{language['nonemployee']}}</a-select-option>-->
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="8">
            <a-form-item :label="language['system.certificate.mrcCode']">
              <a-auto-complete
                allowClear
                @change="mrcCodeChange"
                v-model="queryParam.mrcCode"
                :data-source="mrcCodelist"
                :filter-option="filterOption"
              />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item :label="language['system.certificate.cbCode']">
              <a-auto-complete
                allowClear
                @change="cbCodeChange"
                v-model="queryParam.cbCode"
                :data-source="cbCodelist"
                :filter-option="filterOption"
              />
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="8">
            <a-form-item :label="language['system.certificate.certificateLegalperson']">
              <a-auto-complete
                allowClear
                v-model="queryParam.certificateLegalperson"
                :data-source="certificateLegalpersonlist"
                :filter-option="filterOption"
              />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>

      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('减排凭证表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
<!--      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
<!--      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"

        class="j-table-force-nowrap"
        @change="handleTableChange"><!--:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->

<!--        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>-->


        <span slot="action" slot-scope="text, record">
          <a @click="dataEdit(record)">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <sys-certificate-modal ref="modalForm" @ok="modalFormOk" :systemlist="systemlist"></sys-certificate-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysCertificateModal from './modules/SysCertificateModal'
  import { httpAction,getAction,deleteAction } from '@/api/manage'

  export default {
    name: 'SysCertificateUpLoadList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SysCertificateModal
    },
    data () {
      return {
        value16:'',
        description: '减排凭证表管理页面',
        queryParam: {createBy:this.$store.getters.userInfo.username},
        datalist:[],
        systemlist:[],
        mrcCodelist:[],//管报代码list
        cbCodelist:[],//财报代码list
        certificateLegalpersonlist:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.$store.getters.language['system.certificate.certificateDescribe'],
            align:"center",
            dataIndex: 'certificateDescribe'
          },
          {
            title:this.$store.getters.language['system.certificate.system'],
            align:"center",
            dataIndex: 'systemName'
          },
          {
            title:this.$store.getters.language['system.certificate.mrcCode'],
            align:"center",
            dataIndex: 'mrcCode'
          },
          {
            title:this.$store.getters.language['system.certificate.cbCode'],
            align:"center",
            dataIndex: 'cbCode'
          },
          {
            title:this.$store.getters.language['system.certificate.certificateLegalperson'],
            align:"center",
            dataIndex: 'certificateLegalperson'
          },
          {
            title:this.$store.getters.language['system.uploader'],
            align:"center",
            dataIndex: 'createrUserName'
          },
          {
            title:this.$store.getters.language['system.certificate.createrDepart'],
            align:"center",
            dataIndex: 'createrDepartName'
          },
          {
            title:this.$store.getters.language['system.uploadTime'],
            align:"center",
            dataIndex: 'createTime',
            customRender: function(t, r, index) {
              if(!!r.updateTime){
                return r.updateTime
              }else{
                return r.createTime
              }
            }
          },
          {
            title: this.$store.getters.language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/sys/syscertificate/list/up",
          delete: "/system/syscertificate",
          deleteBatch: "/system/syscertificate/batch",
          exportXlsUrl: "/system/export-xls",
          importExcelUrl: "system/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    // this.getSuperFieldList();
      this.initSystem();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      dataEdit(record){
        if(!!record.lock){
          if(record.lock){
            // this.$message.error(this.language["system.certificate.lockWarning"])
            this.$error({title: this.language['system.tipMessage'], content: this.language["system.certificate.lockWarning"]})
            return;
          }
        }
        this.handleEdit(record);
      },
      handleDelete(id){
        deleteAction("/sys/syscertificate/delete",{id:id}).then(res=>{
          if(res.success){
            this.loadData(1);
            this.$message.success(this.language["operationSuccess"]);
          }else{
            this.$message.error(this.language["common.errorContext"]);
          }
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
      },
      systemCodeChange(v){
        this.datalist = [];
        this.certificateLegalpersonlist = [];
        this.mrcCodelist = []//管报代码list
        this.cbCodelist = []//财报代码list
        if(v){
          getAction("/sys/syscertificatelegalpersonsystems/getDataBySystemCode",{systemCode:v}).then(res=>{
            if(res.success){
              // this.queryParam.certificateLegalpersonId = '';
              let list = res.result;
              if(list){
                this.datalist = list;
                list.forEach(item=>{
                  /*let map = {};
                  map.value = item.legalperson
                  map.text = item.legalperson*/
                  // this.certificateLegalpersonlist.push({value:item.legalperson,text:item.legalperson});
                  this.mrcCodelist.push({value:item.mrcCode,text:item.mrcCode})
                  // this.cbCodelist.push({value:item.cbCode,text:item.cbCode})
                })
              }

            }
          })
        }
      },
      mrcCodeChange(value){
        this.cbCodelist = []//财报代码list
        this.certificateLegalpersonlist = [];
        if(value){
          this.datalist.forEach(item=>{
            if(item.mrcCode == value){
              this.cbCodelist.push({value:item.cbCode,text:item.cbCode})
            }
          })
        }

      },
      cbCodeChange(value){
        this.certificateLegalpersonlist = [];
        if(value){
          this.datalist.forEach(item=>{
            if(item.cbCode == value){
              this.certificateLegalpersonlist.push({value:item.legalperson,text:item.legalperson})
            }
          })
        }
      },
      legalpersonChange(v){
        this.queryParam.certificateLegalperson = v;
      },
      initSystem(){
        getAction("/sys/syscertificatelegalpersonsystems/getAllSystemData").then(res=>{
          if(res.success){
            this.systemlist = res.result;
          }
        })
      },
      searchReset() {
        this.queryParam = {createBy:this.$store.getters.userInfo.username};
      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'systemCode',text:'体系code',dictCode:''})
        fieldList.push({type:'string',value:'certificateLegalperson',text:'法人名称',dictCode:''})
        fieldList.push({type:'string',value:'delFlag',text:'刪除标示(0否 1是)',dictCode:''})
        fieldList.push({type:'string',value:'remark',text:'备注',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
